import { render, staticRenderFns } from "./WordsPopup.vue?vue&type=template&id=2ecad0dc&"
import script from "./WordsPopup.vue?vue&type=script&lang=js&"
export * from "./WordsPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports